import InputControl from "@shared/ui/hook-form/input-control/input-control";
import "./form-person-employment.scss";
import { PersonFormSchema } from "@core/form/form.rule";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import { useFormContext } from "react-hook-form";
import FormDropdownJobTitle from "@domain/job-title/form-dropdown-job-title/form-dropdown-job-title";
import FormDropdownJobGrade from "@domain/job-grade/form-dropdown-job-grade/form-dropdown-job-grade";
import FormDropdownEmploymentType from "@domain/employment-type/form-dropdown-employment-type/form-dropdown-employment-type";
import FormDropdownDepartment from "@domain/department/form-dropdown-department/form-dropdown-department";
import FormDropdownRole from "@domain/role/form-dropdown-role/form-dropdown-role";
import { useUserIdentityContext } from "@core/services/user-identity.context";
import TextBlock from "@shared/ui/text-block/text-block";
import { Accordion, AccordionTab } from "primereact/accordion";
import InputTextareaControl from "@shared/ui/hook-form/input-textarea-control/input-textarea-control";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";
import { useQyGetTerminationType } from "@core/query/termination-type.query";
import { LabelValue } from "@shared/models/label-value.interface";
import { useState } from "react";
import { GetResponseTerminationTypeModel } from "@core/model/query-model-termination-type";

type InputFormSchema = PersonFormSchema;
export function FormPersonEmployment() {
  const { userIsOwner } = useUserIdentityContext();
  const { control, watch } = useFormContext<InputFormSchema>();
  const formRoleName = watch("bucket.roleName") ?? "";
  const [terminationType, setTerminationType] = useState<LabelValue[]>([]);

  const handleGetSuccess = (response: GetResponseTerminationTypeModel) => {
    const responseData = response.data ?? [];
    if (responseData?.length === 0) {
      return;
    }

    const labelValue = LabelValue.MapArray(
      responseData,
      (item) => item.name,
      (item) => item.code
    );
    setTerminationType(labelValue);
  };
  useQyGetTerminationType(
    "",
    9999,
    0,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    true,
    handleGetSuccess
  );

  return (
    <div id="FormPersonEmployment" className="form-person-employment">
      <Accordion activeIndex={0}>
        <AccordionTab header="General">
          {userIsOwner() ? (
            <FormDropdownRole<InputFormSchema> name="bucket.role" />
          ) : (
            <TextBlock
              className="mb-10 block"
              label="Role"
              value={formRoleName}
            />
          )}
          <InputControl<InputFormSchema>
            control={control}
            name="bucket.employeeNo"
            label="Employee Number"
            className="w-full md:w-3/4"
            containerClassName="pb-2"
            placeholder="Enter employee number"
          />
          <InputDateControl<InputFormSchema>
            control={control}
            name="bucket.signedDate"
            label="SignedDate"
            className="w-full md:w-3/4"
            containerClassName="pb-2"
          />
          <InputDateControl<InputFormSchema>
            control={control}
            name="bucket.startDate"
            label="StartDate"
            className="w-full md:w-3/4"
            containerClassName="pb-2"
          />
          <InputDateControl<InputFormSchema>
            control={control}
            name="bucket.endDate"
            label="EndDate"
            className="w-full md:w-3/4"
            containerClassName="pb-2"
          />
          <FormDropdownJobTitle<InputFormSchema> name="bucket.jobTitle" />
          <FormDropdownJobGrade<InputFormSchema> name="bucket.jobGrade" />
          <FormDropdownEmploymentType<InputFormSchema> name="bucket.employmentType" />
          <FormDropdownDepartment<InputFormSchema> name="bucket.department" />
        </AccordionTab>
        <AccordionTab header="Offboard">
          <InputTextareaControl<InputFormSchema>
            control={control}
            name="bucket.offboardReason"
            label="Offboard Reason"
            className="w-full md:w-3/4"
            containerClassName="pb-2"
            placeholder="Enter offboard reason"
          />
          <InputDateControl<InputFormSchema>
            control={control}
            name="bucket.resignationDate"
            label="Resignation Date"
            className="w-full md:w-3/4"
            containerClassName="pb-2"
            placeholder="Enter resignation date"
          />
          <DropdownControl<InputFormSchema>
            control={control}
            name="bucket.terminationType"
            label="Termination type"
            className="w-full md:w-3/4"
            containerClassName="pb-2"
            placeholder="Enter termination type"
            options={terminationType}
          />
          <InputTextareaControl<InputFormSchema>
            control={control}
            name="bucket.remarks"
            label="Remarks"
            className="w-full md:w-3/4"
            containerClassName="pb-2"
            placeholder="Enter Remarks"
          />
          <CheckboxControl<InputFormSchema>
            control={control}
            name="bucket.hasResignationLetter"
            label="Contains Resignation Letter"
            className=""
            containerClassName="pb-2"
          />
          <CheckboxControl<InputFormSchema>
            control={control}
            name="bucket.hasClearance"
            label="Contains Clearance"
            className=""
            containerClassName="pb-2"
          />
          <InputTextareaControl<InputFormSchema>
            control={control}
            name="bucket.managementFeedback"
            label="Management feedback"
            className="w-full md:w-3/4"
            containerClassName="pb-2"
            placeholder="Enter Management feedback"
          />
          <InputTextareaControl<InputFormSchema>
            control={control}
            name="bucket.memoType"
            label="Memo type"
            className="w-full md:w-3/4"
            containerClassName="pb-2"
            placeholder="Enter Memo type"
          />
        </AccordionTab>
      </Accordion>
    </div>
  );
}

export default FormPersonEmployment;
